<template>
	<div
		class="shared-app-aside-item"
		:class="{ 'shared-app-aside-item--stats': stats }">
		<h5
			v-if="title"
			class="shared-app-aside-item__title">
			{{ title }}
			<o-icon
				v-if="icon"
				:font-icon="icon"
				:ripple="callback ? 'info' : undefined"
				@click="callback ? callback() : undefined"/>
		</h5>

		<div
			class="shared-app-aside-item__content"
			:class="{ 'shared-app-aside-item__content--stats': stats }">
			<slot/>

			<o-label
				v-if="progress !== undefined && progress !== null"
				class="shared-app-aside-item__progress"
				:color="progressColor"
				outline>
				<o-icon :icon="setup.progressIcon"/>
				{{ progress }}
			</o-label>
		</div>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedAppAsideItemEmits, SharedAppAsideItemProps } from './SharedAppAsideItemSetup';
import SharedAppAsideItemSetup from './SharedAppAsideItemSetup';
const emits = defineEmits<SharedAppAsideItemEmits>() as SharedAppAsideItemEmits;
const props = withDefaults(defineProps<SharedAppAsideItemProps>(), SharedAppAsideItemSetup.defaultProps);
const setup = new SharedAppAsideItemSetup(props, emits);
// #endregion
</script>

<style lang="less" scoped>
.shared-app-aside-item {
	padding: 1rem 0;
	border-bottom: 0.06rem solid var(--grey-light);

	&__title {
		position: relative;
		font-weight: 400;
		color: var(--grey-dark);

		> .orion-icon {
			position: absolute;
			right: 0.5rem;
		}
	}

	&__content {
		font-weight: 600;
		color: var(--grey-darker);

		&--stats {
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-size: 2rem;
			line-height: 1;
		}

		.router-link-active & {
			color: var(--info);
		}
	}

	&__progress {
		display: inline-flex;
		align-items: center;
		height: 1.5rem;

		> :deep(.orion-label__content) {
			display: flex;
			gap: 0.25rem;
			align-items: center;
		}
	}
}
</style>
